import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import SidebarComponent from "./components/SidebarComponent";
import HeaderComponent from "./components/HeaderComponent";

const AdminLayout = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const toggleSidebar = () => {
        setIsMobileMenuOpen(prev => !prev);
    };
    return (
        <div className="min-h-screen bg-gray-50">
            <HeaderComponent setIsMobileMenuOpen={toggleSidebar} />
            <SidebarComponent isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={toggleSidebar}/>
            <main className="flex-1 lg:pl-64 pt-16 overflow-auto">
                <Outlet />
            </main>
        </div>


    );
};
export default AdminLayout;